import * as types from '../../constants/canvas/StructureActionTypes'
import {env} from '../../constants/Environment';
import _ from 'lodash';

/*export function loadByType(firestore, channel, type, filter){
	return function(dispatch){
        return (new Promise((resolve, reject) => {				
				(async () => {
                    let q = firestore.collection('environments/' + env + '/canvas/' + channel + '/structure/by-type/' + type);
                    if(typeof filter !== 'undefined' && filter !== null)
                        filter.forEach((f) => {q = q.where(f[0], f[1], f[2])});
                    
                    let snapshot = await q.get();
                    
                    if(snapshot.empty)return;
                    let results = [];
                    
                    snapshot.forEach((doc) => {
                        results.push(doc.data());
                    });

                    dispatch({
                        type: types.SET_OBJECT,
                        object: type,
                        data: results,
                        reset: true
                    });
                })();
			}));
    }
}*/

export function loadByType(firestore, channel, type, filter){
	return function(dispatch){
        return (new Promise((resolve, reject) => {				
				(async () => {
                    dispatch({
                        type: types.RESET,
                        object: type
                    });

                    let q = firestore.collection('environments/' + env + '/canvas/' + channel + '/structure/by-type/' + type);
                    if(typeof filter !== 'undefined' && filter !== null)
                        filter.forEach((f) => {q = q.where(f[0], f[1], f[2])});
                    
                    let unsubscribe = q.onSnapshot((snapshot) => {
                        if(snapshot.empty)return;
                        let results = [];
                        
                        snapshot.forEach((doc) => {
                            let data = doc.data();
                            if(typeof data.uid === 'undefined')return;
                                //data.uid = doc.id;
                            results.push(data);
                        });

                        dispatch({
                            type: types.SET_OBJECT,
                            object: type,
                            data: results
                        });
                    });

                    dispatch({
                        type: types.SET_UNSUBSCRIBE_HANDLER,
                        object: type,
                        unsubscribe: unsubscribe
                    });
                })();
			}));
    }
}

export function loadSports(firestore, channel){
	return loadByType(firestore, channel, 'sport', null);
}

export function loadCategories(firestore, channel, sport){
    return loadByType(firestore, channel, 'category', [['sport_uid', '==', sport]]);
}

export function loadCis(firestore, channel, sport){
    return loadByType(firestore, channel, 'cis', [['sport_uid', '==', sport]]);
}

export function loadTournaments(firestore, channel, sport, category){
	return loadByType(firestore, channel, 'tournament', [['category_uid', '==', category], ['sport_uid', '==', sport]]);
}

export function loadMarkets(firestore, channel, sport){
	return loadByType(firestore, channel, 'market', [['sport_uid', '==', sport]]);
}

export function loadOutcomes(firestore, channel, market){
	return loadByType(firestore, channel, 'outcome', [['market_uid', '==', market]]);
}

export function loadOutcomesByType(firestore, channel, marketType){
	return loadByType(firestore, channel, 'outcome', [['market_type', '==', marketType]]);
}

export function loadMarkettypes(firestore, channel, sport){
    return loadByType(firestore, channel, 'markettype', [['sport_uid', '==', sport]]);
}

export function load_missing(firestore, channel, object, existing, needed){
	return function(dispatch){
        return (new Promise((resolve, reject) => {				
				(async () => {
                    const diff = _.difference(needed, existing);

                    let waitFor = [];
                    if(diff.length > 0){
                        let chunks = _.chunk(diff, 10);

                        chunks.forEach((chunk) => {
                            waitFor.push(firestore.collection('environments/' + env + '/canvas/' + channel + '/structure/by-type/' + object).where('uid', 'in', chunk).get());
                        });

                        let snapshots = await Promise.all(waitFor);
                        let results = [];
                        
                        snapshots.forEach((snapshot) => {
                            if(snapshot.empty)return;

                            snapshot.forEach((doc) => {
                                results.push(doc.data());
                            });
                        })

                        dispatch({
                            type: types.SET_OBJECT,
                            object: object,
                            data: results
                        });
                    }
                })();
			}));
    }
}

export function save(firebase, channel, object, id, data){
	return function(dispatch){
        dispatch({
            type: types.TRIGGER_UPDATE,
            object: object,
            id: id,
            channel: channel
        });

        let user = firebase.auth().currentUser.uid;
        let firestore = firebase.firestore();

        return (new Promise((resolve, reject) => {				
				(async () => {
                    let firestore = firebase.firestore();

                    let doc = {
                        cmd: 'UPDATE',
                        scope: object,
                        data: {
                            id: id,
                            content: data
                        },
                        user: user,
                        created: new Date()
                    };
                    await firestore.collection('environments/' + env + '/canvas/' + channel + '/commands').add(doc);

                    resolve();
                })();
			}));
    }
}